<template>
  <div class="about-view">
    <div class="about-header">
      <h1 class="page-title">关于</h1>
      <div class="author-card">
        <div class="author-avatar">
          <img src="/avatar.jpg" alt="作者头像" class="avatar-img" />
        </div>
        <div class="author-info">
          <h3 class="author-name">Hw</h3>
          <p class="author-bio">记录编程学习笔记和技术思考，用文字沉淀知识。</p>
          <div class="author-links">
            <a href="https://github.com/6moran" target="_blank" rel="noopener" class="social-link">
              <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
              <span>GitHub</span>
            </a>
            <a href="https://blog.csdn.net/Mr_morans" target="_blank" rel="noopener" class="social-link">
              <svg class="icon" viewBox="0 0 120 120" fill="currentColor">
                <rect x="0" y="0" width="120" height="120" rx="20"/>
                <text x="60" y="88" font-size="90" font-weight="bold" font-family="Arial" fill="var(--bg)" text-anchor="middle">C</text>
              </svg>
              <span>CSDN</span>
            </a>
            <button class="social-link wechat" @click="showWechatQR = true">
              <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-7.062-6.122zm-2.036 2.87c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.072 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982z"/>
              </svg>
              <span>微信</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="about-content">
      <div class="about-section">
        <h2>技术栈</h2>
        <ul class="tech-list">
          <li>前端：Vue 3 + Vue Router</li>
          <li>后端：Go + Gin</li>
          <li>样式：纯 CSS，支持明暗主题</li>
        </ul>
      </div>

      <div class="about-section">
        <h2>联系方式</h2>
        <p>如果你对文章内容有疑问或建议，欢迎交流。</p>
      </div>
    </div>

    <!-- 微信二维码弹窗 -->
    <div v-if="showWechatQR" class="modal-overlay" @click="showWechatQR = false">
      <div class="modal-content" @click.stop>
        <button class="modal-close" @click="showWechatQR = false">&times;</button>
        <h3>微信扫码添加</h3>
        <img src="/wechat-qr.jpg" alt="微信二维码" class="qr-code" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const showWechatQR = ref(false)
</script>

<style scoped>
.about-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 24px;
  color: var(--text);
}

.author-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-secondary);
}

.author-avatar {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  display: grid;
  place-items: center;
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.author-info {
  min-width: 0;
}

.author-name {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
}

.author-bio {
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.author-links {
  display: flex;
  gap: 12px;
}

.social-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.2s ease;
}

.social-link:hover {
  color: var(--link);
}

.social-link.wechat {
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
}

.icon {
  width: 16px;
  height: 16px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: var(--bg);
  border-radius: 12px;
  padding: 24px;
  position: relative;
  text-align: center;
}

.modal-close {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted);
}

.modal-content h3 {
  margin: 0 0 16px;
  font-size: 16px;
  color: var(--text);
}

.qr-code {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
}

.about-content {
  margin-bottom: 48px;
}

.about-section {
  margin-bottom: 28px;
}

.about-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 12px;
}

.about-section p {
  color: var(--text-secondary);
  line-height: 1.8;
  margin: 0;
}

.tech-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tech-list li {
  padding: 8px 0;
  color: var(--text-secondary);
}

@media (max-width: 600px) {
  .page-title {
    font-size: 24px;
  }

  .author-card {
    gap: 16px;
  }

  .author-avatar {
    width: 52px;
    height: 52px;
  }
}
</style>
